<template>
	<div id="app">
		<keep-alive><router-view v-if="$route.meta.keepAlive"></router-view></keep-alive>
		<router-view v-if="!$route.meta.keepAlive"></router-view>
	</div>
</template>

<script>
import * as appFunc from '@/tools/app-func.js';


export default {
	name: 'App',
	beforeCreate() {
		console.log('App.vue 初始化操作');
		appFunc.initDefaultSetFn(this);
	}
};
</script>

<style>


html {
	overflow: hidden;
}

* {
	padding: 0;
	margin: 0;
	outline: none;
}

*:focus {
	outline: none;
}

.flex-center {
	display: flex;
	justify-content: center;
	align-items: center;
}

/* 给图片添加的 类名 尺寸占 父级所有 */
.image-size {
	width: 100%;
	height: 100%;
}

.text-ellipsis {
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
}

.text-ellipsis-rows {
	/*将对象作为弹性伸缩盒子模型显示*/
	display: -webkit-box;

	/*设置溢出显示类型为...*/
	text-overflow: ellipsis;

	/*设置显示的行数*/
	-webkit-line-clamp: 2;

	/*隐藏多于行*/
	overflow: hidden;

	/*设置或检索伸缩盒对象的子元素的排列方式*/
	-webkit-box-orient: vertical;
}

.border-radius-filled {
	border-radius: 10000000px;
}

.el-message__icon.el-icon-success{
	font-size: 16px;
}

</style>



// WEBPACK FOOTER //
// src/App.vue